import { render, staticRenderFns } from "./StaffRewards.vue?vue&type=template&id=873cfe8c"
import script from "./StaffRewards.vue?vue&type=script&lang=js"
export * from "./StaffRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports